/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./tagTable.vue?vue&type=template&id=6af1b8e8&scoped=true&"
import script from "./tagTable.vue?vue&type=script&lang=js&"
export * from "./tagTable.vue?vue&type=script&lang=js&"
import style0 from "./tagTable.vue?vue&type=style&index=0&id=6af1b8e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af1b8e8",
  null
  
)

export default component.exports